module.exports = __webpack_public_path__ + "assets/img/donate-qr.fa77bba83c75897c6a66aa41a843725b.svg";